import { TemplatesState } from './types';

export const initialState: TemplatesState = {
  themePacks: null,
  loadingThemePacks: false,
  savingThemePack: null,
  creatingThemPack: false,
  templates: null,
  totalTemplates: null,
  loadingTemplatesAndThemes: true, // start true to prevent immediate redirect
  templateFilters: null,
  loadingTemplateFilters: false,
  userFavorites: null,
  loadingUserFavorites: false,
  refetchTemplatesCounter: 0,
  templatesListPage: null,
  renderLoadingList: 0,
  fontPacks: null,
  loadingFontPacks: false,
};
